module.exports = __webpack_public_path__ + "static/media/no_photo_small.528b194e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no_photo/no_photo_small.png
// module id = 1592
// module chunks = 0